/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

const defaultState = {
  loading: false,
  patientList: [],
  viewPatientslist: [],
  selectedViewPatientList: [],
  // patientSpecificDrAnnotationDetailsForSingleImageManipulator: {
  //   prescriptionList: [],
  //   drAdvice: "",
  //   drRecommendation: "",
  //   drRestrictions: "",
  // },
  showAnnotationPatientsOnly: false,
  diagnosticsTests: [],
  totalPatientsCount: 0,
  allPatientReportGenInQueue: false,
  realtimeDescriptor: null,
  realtimePatients: {},
};

const imageKey = (image) => {
  const source = image?.data || image;
  return `${source?.guid || ""}|${source?.Model || ""}|${source?.laterality || ""}`;
};

const mergeEyeProjection = (images, projectedImages) => {
  if (!Array.isArray(images) || !Array.isArray(projectedImages)) return images;
  const projected = new Map(projectedImages.map((image) => [imageKey(image), image]));
  return images.map((image) => {
    const next = projected.get(imageKey(image));
    if (!next) return image;
    return image?.data
      ? { ...image, data: { ...image.data, status: next.data?.status } }
      : { ...image, status: next.status };
  });
};

const mergePatientProjection = (patient, projected) => ({
  ...patient,
  left: mergeEyeProjection(patient.left, projected.left),
  right: mergeEyeProjection(patient.right, projected.right),
  backUpReport:
    patient.backUpReport && projected.backUpReport
      ? {
          ...patient.backUpReport,
          images: mergeEyeProjection(
            patient.backUpReport.images,
            projected.backUpReport.images
          ),
        }
      : patient.backUpReport,
  leftEyeStatus: projected.leftEyeStatus,
  rightEyeStatus: projected.rightEyeStatus,
  isReportAvailable: projected.isReportAvailable,
});

const mergeRealtimePatients = (patients, realtimePatients) =>
  patients.map((patient) => {
    const projected = realtimePatients[String(patient?.mrn)];
    return projected ? mergePatientProjection(patient, projected) : patient;
  });

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_VIEW_PATIENTS": {
      const patients = mergeRealtimePatients(
        action.payload.data.patients,
        state.realtimePatients
      );
      return {
        ...state,
        selectedViewPatientList: [],
        viewPatientslist: patients,
        totalPatientsCount: action.payload.data.totalPatientsCount,
      };
    }
    case "GET_VIEW_PATIENTS_REJECTED": {
      return {
        ...state,
        selectedViewPatientList: [],
        viewPatientslist: [],
      };
    }
    case "REPUBLISH_VIEW_PATIENTS_REALTIME": {
      const patients = mergeRealtimePatients(
        action.payload?.data?.patients || [],
        state.realtimePatients
      );
      const selectedMrns = new Set(
        state.selectedViewPatientList.map((patient) => String(patient?.mrn))
      );
      return {
        ...state,
        viewPatientslist: patients,
        totalPatientsCount: action.payload?.data?.totalPatientsCount,
        selectedViewPatientList: patients.filter((patient) =>
          selectedMrns.has(String(patient?.mrn))
        ),
      };
    }
    case "PATCH_VIEW_PATIENT_REALTIME": {
      const patient = action.payload?.patient;
      const mrn = patient?.mrn;
      if (mrn === undefined || mrn === null || mrn === "") return state;
      const key = String(mrn);
      const viewPatientslist = state.viewPatientslist.map((row) =>
        String(row?.mrn) === key ? patient : row
      );
      return {
        ...state,
        viewPatientslist,
        selectedViewPatientList: state.selectedViewPatientList.map((row) =>
          String(row?.mrn) === key ? patient : row
        ),
        realtimePatients: action.payload?.realtime
          ? { ...state.realtimePatients, [key]: patient }
          : state.realtimePatients,
      };
    }
    case "SET_VIEW_PATIENT_REALTIME_DESCRIPTOR": {
      const realtimeDescriptor = action.payload || null;
      return {
        ...state,
        realtimeDescriptor,
        realtimePatients:
          realtimeDescriptor === null ||
          JSON.stringify(state.realtimeDescriptor) !==
            JSON.stringify(realtimeDescriptor)
            ? {}
            : state.realtimePatients,
      };
    }
    case "SAVE_VIEW_PATIENTS": {
      return {
        ...state,
        viewPatientslist: action.payload?.data,
      };
    }
    case "DELETE_VIEW_PATIENTS": {
      return {
        ...state,
        viewPatientslist: action.payload?.patientsAfterDelete.data,
        totalPatientsCount:
          state.totalPatientsCount - action.payload?.noOfPatientsToDelete,
      };
    }
    case "SELECTED_VIEW_PATIENT_LIST_DATA": {
      return {
        ...state,
        selectedViewPatientList: action.payload,
        loading: false,
        // errors: {},
      };
    }
    case "GET_DIAGNOSTICS_TESTS": {
      return {
        ...state,
        diagnosticsTests: action.payload,
      };
    }
    case "UPDATE_PATIENT_SELECTED": {
      return {
        ...state,
        selectedViewPatientList: action.payload,
        allPatientReportGenInQueue: true,
      };
    }
    case "SHOW_ANNOTATION_PATIENTS_ONLY": {
      return {
        ...state,
        showAnnotationPatientsOnly: !state.showAnnotationPatientsOnly,
      };
    }
    // case "SAVE_PRESCRIPTION": {
    //   return {
    //     ...state,
    //     patientSpecificDrAnnotationDetailsForSingleImageManipulator: {
    //       ...state.patientSpecificDrAnnotationDetailsForSingleImageManipulator,
    //       prescriptionList: [...action.payload],
    //     },
    //   };
    // }
    // case "SAVE_MRN_SPECIFIC_DR_ANNOTATION_DETAILS": {
    //   return {
    //     ...state,
    //     patientSpecificDrAnnotationDetailsForSingleImageManipulator:
    //       action.payload,
    //   };
    // }
    default:
      return state;
  }
  return state;
};
